import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CompanyAccountApi, IncomeInvoiceApi, PropertySettlementApi } from 'app/shared/services/sdk';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-collect-commission',
    templateUrl: './collect-commission.component.html',
    styleUrls: ['./collect-commission.component.scss']
})
export class CollectCommissionComponent implements OnInit {
    period_start_date: any;
    period_end_date: any;
    property_list: any;
    selectedProperties: any;
    collectCommissionForm: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<CollectCommissionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private appLoader: AppLoaderService,
        private companyAccountApi: CompanyAccountApi,
        private propertySettlementApi: PropertySettlementApi,
        private incomeInvoiceApi: IncomeInvoiceApi
    ) {}

    ngOnInit() {
        this.collectCommissionForm = this.fb.group({
            collection_date: ['', Validators.required],
            property_id: ['', Validators.required],
            description: ['',Validators.required]
        });

        this.getProperties();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    getProperties() {
        this.companyAccountApi
            .find({
                where: { company_role: 'PROPERTY', property_status: 'ACTIVE' },
                fields: ['id', 'property_name']
            })
            .subscribe(res => {
                this.property_list = res;
            });
    }

    onSubmit() {
        this.appLoader.open('Posting commissions');

        this.propertySettlementApi.processSettlement({
            property_id: this.collectCommissionForm.get('property_id').value,
            collection_date: this.collectCommissionForm.get('collection_date').value,
            description: this.collectCommissionForm.get('description').value
        }).subscribe(res=>{
            this.appLoader.close();

            // Nothing is posted when no new payments came in since the last remittance
            if (!res || !res.length) {
                this.toastr.info(
                    'No new payments since the last remittance for this property, so nothing was posted.',
                    'Nothing to remit'
                );
                return;
            }

            this.toastr.success(
                'Commissions successfully posted.',
                'Commissions created.'
            );
            this.dialogRef.close();
        },error => {
            this.appLoader.close();
            this.toastr.error(
                'Something went wrong when posting commissions',
                'Error'
            );
        })


    }
}
